export const OBSERVACAO_MAX_LENGTH = 900

export const observacaoFields = [
    {
        key: "observacao",
        label: "Observação",
        md: 12,
        type: "dynamicTextarea",
        longText: true,
        maxLength: OBSERVACAO_MAX_LENGTH,
        minRows: 3,
        maxRows: 8,
        ocr: false,
        defaultValue: null,
        inputProps: {
            placeholder: "Informações adicionais relevantes sobre o cadastro.",
        },
    },
]